import ActionTypes from "../../../../constants/ActionTypes";
import {
  IRequestFetchAllCampaignOffersAction, IRequestHelpCampaignAction,
  ISetCampaignListDataAction, ISetChannel01OreOffersAction,
  ISetChannel01SoftOffersAction, ISetCurrentTpAction, ISetWebosOreOffersAction,
  ISetWebosSoftOffersAction,
} from "./types";
import SoftOffer from "../../../../entities/campaigns/offers/SoftOffer";
import OreOffer from "../../../../entities/campaigns/offers/OreOffer";
import { ISoftOfferPackage } from "../../../../entities/campaigns/types";

export function requestFetchAllCampaignOffersAction(params: object): IRequestFetchAllCampaignOffersAction {
  return {
    type: ActionTypes.CAMPAIGN.FETCH_ALL,
    params,
  };
}

export function setCampaignListDataAction(campaignData: any): ISetCampaignListDataAction {
  return {
    type: ActionTypes.CAMPAIGN.LIST.CREATE,
    payload: campaignData,
  };
}

export function setWebosSoftOffersAction(offers: SoftOffer[]): ISetWebosSoftOffersAction {
  return {
    type: ActionTypes.CAMPAIGN.LIST.SET_WEBOS_SOFT,
    payload: offers,
  };
}

export function setChannel01SoftOffersAction(offers: SoftOffer[]): ISetChannel01SoftOffersAction {
  return {
    type: ActionTypes.CAMPAIGN.LIST.SET_CHANNEL01_SOFT,
    payload: offers,
  };
}

export function setWebosOreOffersAction(offers: OreOffer[]): ISetWebosOreOffersAction {
  return {
    type: ActionTypes.CAMPAIGN.LIST.SET_WEBOS_ORE,
    payload: offers,
  };
}

export function setChannel01OreOffersAction(offers: OreOffer[]): ISetChannel01OreOffersAction {
  return {
    type: ActionTypes.CAMPAIGN.LIST.SET_CHANNEL01_ORE,
    payload: offers,
  };
}

export function setCurrentTpAction(tp: ISoftOfferPackage, actualSubscription: number): ISetCurrentTpAction {
  return {
    type: ActionTypes.CAMPAIGN.LIST.SET_CURRENT_TP,
    payload: {
      tp,
      actualSubscription
    },
  };
}

export function requestCampaignHelpAction(callMeData: any): IRequestHelpCampaignAction {
  return {
    type: ActionTypes.CAMPAIGN.CALL_ME,
    payload: callMeData,
  };
}
